import { handleTileVisibility, onFilterButtonClick, onFilterSelectChange } from './modules/events';
import { getFilterTaxonomy } from './modules/helper';
import { classes, FILTER_CHANGE_EVENT_TYPE, selectors } from './modules/lib';

const getDefaultFilterValue = (el) => {
	const taxonomy = getFilterTaxonomy(el);
	if (!taxonomy) return '';

	// Check if the URL contains a search query parameter
	const urlParams = new URLSearchParams(window.location.search);
	return urlParams.get(`filter_${taxonomy}`) || '';
};

const initFilterSelect = (el) => {
	const select = el.querySelector(selectors.filterSelect);
	if (!select) {
		return;
	}

	const defaultValue = getDefaultFilterValue(el);
	if (defaultValue) {
		const targetFilterElement = el.querySelector(`${selectors.filterSelect} option[value="${defaultValue}"]`);
		select.value = targetFilterElement ? defaultValue : '';
	}

	// Dispatch a change event to show the correct tiles on page load
	select.dispatchEvent(new Event('change'));
};

const initFilterButtons = (el) => {
	const filterButtons = el.querySelectorAll(selectors.filterButton);
	if (!filterButtons.length) {
		return;
	}

	const defaultValue = getDefaultFilterValue(el);
	const targetFilterElement = el.querySelector(`${selectors.filterButton}[data-cat="${defaultValue}"]`);
	if (defaultValue && targetFilterElement) {
		if (!targetFilterElement.classList.contains(classes.active)) {
			targetFilterElement.click();
		}
	} else {
		// If one filter element is always on or the first filter element should be preselected, the first filter element is clicked.
		if ([classes.filterSelectFirst, classes.filterAlwaysOn].some((className) => el.classList.contains(className))) {
			el.querySelector(selectors.filterButton)?.click();
		}
	}
};

const initCallback = (el) => {
	/**
	 * Add the event listeners
	 */

	// Add the filter change event listener to the filter navigation element
	el.addEventListener(FILTER_CHANGE_EVENT_TYPE, (e) => {
		handleTileVisibility(el.nextElementSibling, e.detail.filterValue);
	});

	// Mobile Control: Add the change event listener to the select element
	el.querySelector(selectors.filterSelect)?.addEventListener('change', onFilterSelectChange);

	// Desktop Control: Add the click event listener to every filter button
	el.querySelectorAll(selectors.filterButton).forEach((filterEl) => filterEl.addEventListener('click', onFilterButtonClick));

	/**
	 * Initialize the filter control elements
	 */

	initFilterSelect(el);
	initFilterButtons(el);
};

document.querySelectorAll(selectors.filterNavigation).forEach(initCallback);
